import {FilterableList} from "../filterable-list";
import {Helpers} from "../helpers/helpers";
import {FilterParameter, SearchResults} from "../models/types"
import {EventItem} from "../models/eventItem";


export class ResourceList extends FilterableList<ResourceViewModel>
{
	filterWrapper: HTMLElement;
	public totalResults = 0;
	
	public constructor(private sectionSelector: string, private onResultsLoaded:(results:SearchResults<ResourceViewModel>)=> void = null, pageSize = 12) {		
		super(sectionSelector + ' .card-list', `${sectionSelector} .no-results`, ".filters-container",pageSize);	
		
	}

	createResult(dataItem: ResourceViewModel): void {
		const resourceSection = document.querySelector(this.sectionSelector) as HTMLElement;
		const templateCard = resourceSection.querySelector('.resource-item-template .card') as HTMLElement
		const type = this.resultsWrapper.dataset.type;
		let template:HTMLElement;
		if (type === "Event") {
			template = ResourceList.createEventCard(dataItem.eventModel, templateCard.closest('.col-md-4'));	
		}
		else {
			template = ResourceList.createResourceCard(dataItem, templateCard);
		}
		this.resultsWrapper.append(template);
	}

	clearResults(): void {
		if (this.resultsWrapper) {
			this.resultsWrapper.innerHTML = "";
		}
	}

	onQueryChange(selectedFilters: FilterParameter[]): void {
		if (selectedFilters.length > 0) {
			document.querySelector('.section-expandable.expanded')?.classList.remove('expanded');
		}
		const resourceSection = document.querySelector(this.sectionSelector) as HTMLElement;
		const parentSection = resourceSection.closest('.section-content');
		const type = this.resultsWrapper.dataset.type;
		parentSection?.classList.remove('d-none');
		
		this.search("/resources/search", selectedFilters, false, (results: SearchResults<ResourceViewModel>)=> {
			const hasResults = this.resultsWrapper.querySelectorAll('.card').length > 0;
			if (!hasResults) {
				parentSection?.classList.add('d-none');				
			}
			
			//update view all buttons.
			let viewAllButton = parentSection?.querySelector('.view-all') as HTMLAnchorElement;
			if (viewAllButton) {
				let viewMoreText = viewAllButton.dataset.viewmore ?? "View More";
				let viewAllText = viewAllButton.dataset.viewall ?? "View All";
				let viewAllUrl = viewAllButton.dataset.viewallurl ?? "/resources";
				
				viewAllButton.innerText = selectedFilters.length >0 ? viewMoreText : viewAllText;
				if (selectedFilters.length > 0) {
					let params = Helpers.getUrlParameters();
					let resourceViewAllLink = viewAllUrl;
					viewAllButton.innerText = viewMoreText;
					if (params) {
						resourceViewAllLink += "?filters=" + params['filters'];
					}
					viewAllButton.href = resourceViewAllLink;
				} else {
					viewAllButton.href = viewAllUrl;
					viewAllButton.innerText = viewAllText;
				}
			}
			
			
			this.totalResults = results.totalCount;
			if (this.onResultsLoaded) {
				this.onResultsLoaded(results);
			}		
			
		}, this.pageSize, type ?? "");
	}

	toggleLoader(isLoading: boolean): void {
		const loader = this.resultsWrapper.parentElement.querySelector(' .loader');		
		if (isLoading) {
			loader.classList.remove('d-none');
			
			
		} else {
			loader.classList.add('d-none');
			this.resultsWrapper.classList.remove('d-none');			
			this.paginationContainer?.classList.remove('d-none');
			
		}
	}

	static createEventCard(dataItem: EventItem, templateCard: HTMLElement = null) : HTMLElement {
		if (!templateCard) {
			templateCard = document.querySelector('.resource-item-template .card');
		}
		let template = templateCard.cloneNode(true) as HTMLElement;
		let image = template.querySelector('.image');
		let title = template.querySelector('h2');
		let urlElement = template.querySelector('.card.event-card') as HTMLAnchorElement;
		let startDateBadge = template.querySelector('.content-wrapper > .start-date');
		let eventDateElement = template.querySelector('.content-wrapper .event-date strong');
		let timeElement = template.querySelector('.content-wrapper .time strong');
		let contentUL = template.querySelector('.content-wrapper ul');		
		
		const startDate = new Date(dataItem.startDate);
		const endDate = new Date(dataItem.endDate);
		const month = startDate.toLocaleString('default', { month: 'short' });
		startDateBadge.innerHTML = ` ${month}<span>${startDate.getDay()}</span>`;		
		if (dataItem.imageUrl) {
			var img = document.createElement("img") as HTMLImageElement;
			img.alt = dataItem.name;
			img.src = dataItem.imageUrl.replace("~", "");
			image.append(img);
			image.querySelector('.no-image').remove();
		}
	
		startDate.setHours(0,0, 0,0);
		endDate.setHours(0,0, 0,0);
		const options : Intl.DateTimeFormatOptions = {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		};
		if (startDate === endDate) {
			eventDateElement.innerHTML = startDate.toLocaleString('default', options);
		} else {
			eventDateElement.innerHTML = `${startDate.toLocaleString('default', options)} - ${endDate.toLocaleString('default', options)}`;
		}
		

		let url =  dataItem.isExternalLink ? dataItem.externalUrl : dataItem.eventLink;
		if (!url && dataItem.eventLink) {
			url = dataItem.eventLink;
		}
		title.innerHTML = dataItem.name;	
		urlElement.href = url?.replace("~", "");
		timeElement.innerHTML = dataItem.time;
		
		if (dataItem.cDPCertified > 0) {			
			let cpdElement = `<li><icon name="folders" />CDP Certified: <strong>${dataItem.cDPCertified}</strong></li>`;
			contentUL.append(cpdElement);
		}

		if (dataItem.pDHCredits > 0) {
			let pdhElement = `<li><icon name="folders" />PDH Credits: <strong>${dataItem.pDHCredits}</strong></li>`;
			contentUL.append(pdhElement);
		}

		return template;
	}
	
	static createResourceCard(dataItem: ResourceViewModel, templateCard: HTMLElement = null) : HTMLElement {
		if (!templateCard) {
			templateCard = document.querySelector('.resource-item-template .card');
		}
		let template = templateCard.cloneNode(true) as HTMLElement;
		let image = template.querySelector('.image');
		let title = template.querySelector('h3');
		let urlElement = template as HTMLAnchorElement;
		let content = template.querySelector('.content .summary');
		let tags = template.querySelector('.tags');
		let badge = template.querySelector('.badge');
		if (dataItem.thumbnailImageUrl) {
			var img = document.createElement("img") as HTMLImageElement;
			img.alt = dataItem.title;
			img.src = dataItem.thumbnailImageUrl.replace("~", "");
			image.append(img);
			image.querySelector('.no-image').remove();
		}

		const isExternalLink = dataItem.externalUrl && dataItem.resourceType !== "Webinar" && dataItem.resourceType !== "Article";

		const url = isExternalLink ? dataItem.externalUrl : dataItem.url;

		title.innerHTML = dataItem.title;
		if (dataItem.summary) {
			content.innerHTML = Helpers.trimText(dataItem.summary, 150);
		}
		urlElement.href = url.replace("~", "");
		if (isExternalLink || url.indexOf('.pdf') !== -1) {
			urlElement.target = "_blank";
		}
		tags.innerHTML = dataItem.tags;
		if (dataItem.resourceType === "Download") {
			badge.classList.add('secondary');
		}
		badge.innerHTML = dataItem.resourceTypeName;

		return template;
	}


}

export interface ResourceViewModel {
	thumbnailImageUrl: string;
	title: string;
	date: string;
	url: string;
	content: string;
	externalUrl: string;
	summary: string;
	resourceType: string;
	resourceTypeName: string;
	eventModel: EventItem;
	videoEmbedUrl: string;
	tags: string;
}